/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Picture} from './Picture';
import {YouTube} from './YouTube';
import {Document} from './Document';
import {ProductCodeValue} from './ProductCodeValue';
import {ProductPricePlain} from './ProductPricePlain';
import {ProductRemainPlain} from './ProductRemainPlain';
import {Catalog} from './Catalog';

export interface ProductPlain {
  id: number;
  header: string;
  headerAuto: string;
  fullHeader: string;
  barCode?: string;
  articul?: string;
  content?: string;
  description?: string;
  syncUid?: string;
  price: number;
  enabled: boolean;
  deleted?: boolean;
  supplyTerm?: number;

  updatedAt?: Date;
  createdAt?: Date;
  deletedAt?: Date;
  pos: number;

  catalogId?: number;
  catalogHeader?: string;
  manufacturerId?: number;
  manufacturerSeriesId?: number;
  featureUnionConditionId?: number;
  countryId?: number;
  supplierId?: number;
  parentId?: number;
  productClassId?: number;
  productStatusId?: number;
  productGroupId?: number;
  unitId?: number;
  pictureId?: number;

  width?: number;
  height?: number;
  length?: number;
  weight?: number;
  volume?: number;
  guaranty?: number;

  manufacturerSiteLink?: number;
  multiplicitySupplier?: number;
  multiplicityOrder?: number;
  minOrderQuantity?: number;

  picture: Picture;
  pictures: Picture[];
  documents: Document[];
  catalogs?: Catalog[];
  productTags?: number[];
  productSystemTags?: number[];

  analogs?: ProductPlain[];
  relatedGoods?: ProductPlain[];
  videos?: YouTube[];
  codes?: ProductCodeValue[];
  parent?: ProductPlain;
  linkedGoods?: ProductPlain[];

  prices?: ProductPricePlain[];
  remains?: ProductRemainPlain[];
}
